// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewSensoryCategory } from './BrewSensoryCategory';
import { operatorId } from './Operator';
import { z } from 'zod';
export const brewSensoryFormId = (z.number());
export const brewSensoryForm = z.object({
    id: brewSensoryFormId,
    name: z.string(),
    category: brewSensoryCategory,
    archived_at: z.date().nullable(),
    archived_by: operatorId.nullable(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const brewSensoryFormInitializer = z.object({
    id: brewSensoryFormId.optional(),
    name: z.string(),
    category: brewSensoryCategory,
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const brewSensoryFormMutator = z.object({
    id: brewSensoryFormId.optional(),
    name: z.string().optional(),
    category: brewSensoryCategory.optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=BrewSensoryForm.js.map